var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LinksField',{attrs:{"def":_vm.def,"title":_vm.title,"max":1,"userMayEditFields":_vm.userMayEditFields},on:{"subedit":function($event){return _vm.$emit('subedit', $event)},"subcreate":function($event){return _vm.$emit('subcreate', $event)}},model:{value:(_vm.entries),callback:function ($$v) {_vm.entries=$$v},expression:"entries"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }